// extracted by mini-css-extract-plugin
export default {"appLayout":"AppLayout_appLayout__DIZqZ"};